function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

/* eslint arrow-body-style: 0 */
const {
  poll
} = require('./poll');
/*:: interface TaskResult {
  id: string;
  status: 'SUCCESS' | 'FAILED' | 'PENDING';
  type: string;
  input: { [key: string]: any };
  output?: { [key: string]: any };
  updated: string;
  created: string;
}*/

/*:: interface WatchOptions {
  onProgress?: (result: TaskResult) => void,
  interval?: number,
  timeout?: number
}*/


function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

const watchTask = _async(function (taskId
/*: string*/
, taskCheckFn
/*: ((taskId: string) => Promise<TaskResult>)*/
, {
  /*: WatchOptions*/

  onProgress,
  interval,
  timeout
} = {}) {
  return poll(_async(function () {
    let _exit = false;
    let result;
    return _continue(_catch(function () {
      return _await(taskCheckFn(taskId), function (_taskCheckFn) {
        result = _taskCheckFn;
      });
    }, function (err) {
      // Task is not synchronously available so we just wait for it...
      if (err.status === 404) {
        _exit = true;
        return false;
      }

      throw err;
    }), function (_result) {
      if (_exit) return _result;

      switch (result.status) {
        case 'SUCCESS':
          return result.output;

        case 'FAILED':
          throw result;

        default:
          if (onProgress) {
            onProgress(result);
          }

          return false;
      }
    });
  }), interval, timeout);
});

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function _continue(value, then) {
  return value && value.then ? value.then(then) : then(value);
}

module.exports = watchTask;